import { useMutation, useQueryClient } from 'react-query';
import { AxiosError } from 'axios';
import { Axios } from '@utils/api/axios-instance.ts';
import { POST_URL } from '@utils/api/endpoints.ts';
import { QueryKeys } from '@utils/api/query-keys.ts';
import type { BaseError } from '@utils/types/shared/base.ts';
import type {
  Connection,
  ConnectionResponse,
  FinalizeConnectionPayload
} from '@utils/types/connections/connection.ts';

async function finalizeConnection(
  payload: FinalizeConnectionPayload
): Promise<Connection> {
  const { data } = await Axios.post<ConnectionResponse>(
    POST_URL().finalizeConnection,
    payload
  );
  return data.result;
}

export function useFinalizeConnection() {
  const queryClient = useQueryClient();

  return useMutation<
    Connection,
    AxiosError<BaseError>,
    FinalizeConnectionPayload
  >(finalizeConnection, {
    onSuccess: () => {
      queryClient.invalidateQueries(QueryKeys.connections());
    },
    useErrorBoundary: false
  });
}
